module.exports = __webpack_public_path__ + "static/media/44th-and-2nd.776798ea.jpeg";